import axios from "axios";

export const GET_ADVERTS = "v1/connections";
export const GET_ADVERTS_OF_CATEGORY = "v1/connections/city";
export const GET_ADVERT_DETAIL = "v1/connections/";
export const CREATE_ADVERT = "v1/connections";
export const CREATE_ADVERT_WITHOUT_LOGIN = "v1/connections/withoutLogin";
export const SEARCH_ADVERT = "v1/connections/search";

// Take and buy advert
export const TAKET_ADVERT = "v1/cashier/takeAdvert/";

export function getAdverts() {
  return axios.get(GET_ADVERTS);
}

/**
 * getAdvertsWithPaginate
 * @param {number} page
 * @param {number} limit
 * @param {string} order
 */
export function getAdvertsWithPaginate(page, limit, order, kind) {
  let url = `${GET_ADVERTS}?page=${page}&limit=${limit}&sortBy=createdAt:${order}`;
  if (kind) url += `&kind=${kind}`;
  return axios.get(url);
}

/**
 * En çok görüntülenen ilanlar (vitrin/popüler bölümü için).
 * sortBy=viewCount:desc backend paginate plugin tarafından destekleniyor.
 */
export function getPopularAdverts(limit, kind) {
  let url = `${GET_ADVERTS}?page=1&limit=${limit}&sortBy=viewCount:desc`;
  if (kind) url += `&kind=${kind}`;
  return axios.get(url);
}

export function getAdvertsOfCityWithPaginate(page, limit, order, city, kind) {
  let url = `${GET_ADVERTS_OF_CATEGORY}?page=${page}&limit=${limit}&sortBy=createdAt:${order}&city=${city}`;
  if (kind) url += `&kind=${kind}`;
  return axios.get(url);
}

export function getAdvertDetail(advertId) {
  return axios.get(GET_ADVERT_DETAIL + advertId);
}

export function getSimilarAdverts(advertId, body) {
  return axios.post(GET_ADVERT_DETAIL + advertId + "/similar", body);
}

export function takeAdvert(advertId) {
  return axios.get(TAKET_ADVERT + advertId);
}

export function createAdvert(advertFormData) {
  return axios.post(CREATE_ADVERT, advertFormData);
}

export function createAdvertWithoutLogin(formData) {
  return axios.post(CREATE_ADVERT_WITHOUT_LOGIN, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function searchAdvert(keyword) {
  return axios.post(SEARCH_ADVERT, { keyword });
}

// Append photos to an existing advert (used by seller flow when logged in).
export function uploadAdvertImages(advertSlug, files) {
  const fd = new FormData();
  for (const f of files) fd.append("image", f);
  return axios.post(`${GET_ADVERT_DETAIL}${advertSlug}/images`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}
